import { IResult } from '../types/IResponse';
import { ISiteOIDCConfiguration } from '../types/ISiteOIDCConfiguration';
import { Request } from './Request';

export interface ISiteOIDCConfigurationViewModel extends IResult {
  knownProviderAliases: string[];
  configuration: ISiteOIDCConfiguration;
}

export class GetOrCreateSiteOIDCConfigurationViewModelRequest extends Request<{}, ISiteOIDCConfigurationViewModel> {
  constructor() {
    super('getOrCreateSiteOIDCConfigurationViewModel', {});
  }
}
